/**
 * @generated SignedSource<<0445460a761bf9e474c0d5c6f89cd52e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type onePostMagSectionTopWidgetSponsorQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"postMagazinePrimaryContent">;
  };
  readonly " $fragmentType": "onePostMagSectionTopWidgetSponsorQueueItemsEdge";
}>;
export type onePostMagSectionTopWidgetSponsorQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: onePostMagSectionTopWidgetSponsorQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"onePostMagSectionTopWidgetSponsorQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "onePostMagSectionTopWidgetSponsorQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "postMagazinePrimaryContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "984dc273678dbb598bbc324aabfbe792";

export default node;
